/** Fundraising layout with sidebar navigation (spec-21). */

import { Filter, HandCoins, Mail, Sparkles, Users } from 'lucide-react'
import type { NavSection } from '@/layouts/navTypes'
import { WorkspaceLayout } from '@/layouts/WorkspaceLayout'

/** Sidebar nav sections for fundraising. `end` on the index route keeps
 *  "Dashboard" from lighting up on every /fundraising/* child. */
const NAV_SECTIONS: readonly NavSection[] = [
  {
    title: 'Fundraising',
    items: [
      { to: '/fundraising', label: 'Dashboard', icon: HandCoins, end: true },
      { to: '/fundraising/funnel', label: 'Sales Funnel', icon: Filter },
      { to: '/fundraising/investeerders', label: 'Investeerders', icon: Users },
      { to: '/fundraising/suggesties', label: 'Suggesties', icon: Sparkles },
      { to: '/fundraising/mails', label: 'Mails', icon: Mail },
    ],
  },
] as const

/**
 * Fundraising shell. The chrome lives in WorkspaceLayout; this component only
 * supplies the nav. No footer item here — fundraising has no "Mijn taken".
 */
export function FundraisingLayout() {
  return <WorkspaceLayout navSections={NAV_SECTIONS} />
}
